import { apiGet, apiPost, API_PATH } from "../api/client";

export interface GroupInfo {
  id: number;
  name: string;
}

export interface InvitationScanResponse {
  invitationId: string;
  instanceId: number;
  defaultGroupIds: number[];
  expiresAt: string;
  status: string;
  targetInstanceName?: string | null;
  targetInstanceIcon?: string | null;
  groupNames?: GroupInfo[];
}

export interface InvitationScanResult {
  status: string;
  data: InvitationScanResponse;
}

export interface InvitationConfirmResult {
  accessId: number;
  status: string;
  message: string;
}

export const InvitationsService = {
  async scanInvitation(qrToken: string): Promise<InvitationScanResult> {
    return apiGet<InvitationScanResult>(
      `${API_PATH}/invitations/scan/${encodeURIComponent(qrToken)}`,
    );
  },

  async confirmInvitation(
    qrToken: string,
    action: "accept" | "expired",
  ): Promise<InvitationConfirmResult> {
    return apiPost<InvitationConfirmResult>(
      `${API_PATH}/invitations/scan/${encodeURIComponent(qrToken)}/confirm/${action}`,
    );
  },
};
